import React, { Component }  from 'react';
import lodash               from 'lodash';
import { Button }           from 'primereact/button';
import { Fieldset }         from 'primereact/fieldset';
import { Avatar }           from 'primereact/avatar';
import { BreadCrumb }       from 'primereact/breadcrumb';
import { TabPanel } from 'primereact/tabview';
import { TabViewComErro } from 'hay-core-react';
import Configuracao                           from '../../../models/Configuracao';
import HomologacaoIntegracao                  from '../../../models/HomologacaoIntegracao';
import ConfiguracaoConfirmacaoCadastroEnum    from '../../../enums/ConfiguracaoConfirmacaoCadastroEnum';
import ConfiguracaoRequercpfEnum              from '../../../enums/ConfiguracaoRequercpfEnum';
import ConfiguracaoRequercidadeEnum           from '../../../enums/ConfiguracaoRequercidadeEnum';
import ConfiguracaoRequerdatanascimentoEnum   from '../../../enums/ConfiguracaoRequerdatanascimentoEnum';
import ConfiguracaoTipoEnvioEmailEnum         from '../../../enums/ConfiguracaoTipoEnvioEmailEnum';
import ConfiguracaoIdentificacaoMercadoPagoEnum from '../../../enums/ConfiguracaoIdentificacaoMercadoPagoEnum';
import ConfiguracaoImagemTelaInicialFormatoEnum from '../../../enums/ConfiguracaoImagemTelaInicialFormatoEnum';
import ConfiguracaoTemaCaptiveEnum            from '../../../enums/ConfiguracaoTemaCaptiveEnum';
import ConfiguracaoTamanhoFonteCaptiveEnum    from '../../../enums/ConfiguracaoTamanhoFonteCaptiveEnum';
import TipoLoginEnum                          from '../../../enums/TipoLoginEnum';
import { ModelTextInput } from 'hay-core-react';
import { ModelUrl } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { ModelMultiSelect } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { ModelFile } from 'hay-core-react';
import { ModelSenha } from 'hay-core-react';
import { ModelInputNumber } from 'hay-core-react';
import { ModelSlider } from 'hay-core-react';
import { EntityGrid } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import TemaCaptiveOptionLabel                 from '../../../components/ui/TemaCaptiveOptionLabel';
import TamanhoFonteCaptiveOptionLabel          from '../../../components/ui/TamanhoFonteCaptiveOptionLabel';
import TesteAparenciaCaptiveButton            from '../../../components/ui/TesteAparenciaCaptiveButton';
import MercadoPagoWebhookAjuda                from '../../../components/ui/MercadoPagoWebhookAjuda';

// ─── Validação dinâmica: obrigatoriedade de integracaourl/credencial/secret ──
// depende da HomologacaoIntegracao selecionada (model.homologacaointegracao.value já vem com o
// registro completo — ModelDropDown busca via entidade.list(), que retorna todos os atributos).
// Só valida no front-end (ver especificação 148) — sem enforcement equivalente no backend.
function validarObrigatoriedadeIntegracao(definicoes, model, campoObrigatoriedade) {
    const integracao = model.homologacaointegracao.value;
    const obrigatoriedade = integracao?.[campoObrigatoriedade];
    if (!obrigatoriedade) return null; // sem integração selecionada, ou integração sem esse campo
    if (obrigatoriedade.endsWith('.obrigatorio') && !definicoes.value) {
        return 'Obrigatório para a integração selecionada.';
    }
    return null;
}

// ─── Model do EntityGrid (modo admin) ────────────────────────────────────────

const modelAdmin = {
    id: { value: null },
    // Sem campo publicacao proprio aqui - o EntityGrid injeta coluna/campo automaticamente pra
    // quem tem permissoes.permiteacessogeral (mesma condicao de todo outro grid, ver
    // especificacao 186), sem precisar de ocultarColunaPublicacao/renderer proprio.
    descricao: {
        exibir: 'main.configuracao.descricao',
        visivel: true,
        validacao: { obrigatorio: true },
    },
    ativarcaptive: {
        exibir: 'main.configuracao.ativarcaptive',
        visivel: true,
        tipo: 'boolean',
        template: 'ativarcaptive.template',
    },
    ativarequivalencia:          { exibir: 'main.configuracao.ativarequivalencia' },
    homologacaointegracao: {
        exibir:       'main.configuracao.homologacaointegracao',
        tipo:         'relacao',
        camporelacao: 'descricao',
        entidade:     'homologacaointegracao.entidade',
        template:     'homologacaointegracao.template',
    },
    integracaourl:                { exibir: 'main.configuracao.integracaourl', tipo: 'url', validacao: { url: true, customizada: (def, model) => validarObrigatoriedadeIntegracao(def, model, 'obrigatoriedadeurl') } },
    integracaocredencial:         { exibir: 'main.configuracao.integracaocredencial', validacao: { customizada: (def, model) => validarObrigatoriedadeIntegracao(def, model, 'obrigatoriedadecredencial') } },
    integracaosecret:             { exibir: 'main.configuracao.integracaosecret', validacao: { customizada: (def, model) => validarObrigatoriedadeIntegracao(def, model, 'obrigatoriedadesecret') } },
    mercadopagoaccesstoken:       { exibir: 'main.configuracao.mercadopagoaccesstoken' },
    mercadopagopublickey:         { exibir: 'main.configuracao.mercadopagopublickey' },
    mercadopagowebhooksecret:     { exibir: 'main.configuracao.mercadopagowebhooksecret' },
    identificacaomercadopago:      { exibir: 'main.configuracao.identificacaomercadopago', tipo: 'enum', entidade: 'configuracao.identificacaomercadopago' },
    urlredirect:                 { exibir: 'main.configuracao.urlredirect', tipo: 'url', validacao: { url: true } },
    logincommac:                 { exibir: 'main.configuracao.logincommac' },
    diasvalidadelogincommac:     { exibir: 'main.configuracao.diasvalidadelogincommac', tipo: 'numeric', keyfilter: 'num' },
    tipologin:                   { exibir: 'main.configuracao.tipologin', tipo: 'multiselect', entidade: 'configuracao.tipologin', validacao: { obrigatorio: true } },
    tipologinpadrao:             { exibir: 'main.configuracao.tipologinpadrao', tipo: 'enum', entidade: 'configuracao.tipologin' },
    exigirtermosdeuso:           { exibir: 'main.configuracao.exigirtermosdeuso' },
    apitokensms:                 { exibir: 'main.configuracao.apitokensms' },
    ativarsms:                   { exibir: 'main.configuracao.ativarsms' },
    ativaremail:                 { exibir: 'main.configuracao.ativaremail' },
    tipoenvioemail:              { exibir: 'main.configuracao.tipoenvioemail', tipo: 'enum', entidade: 'configuracao.tipoenvioemail' },
    origem:                      { exibir: 'main.configuracao.origem' },
    usuariosmtp:                 { exibir: 'main.configuracao.usuariosmtp' },
    senhasmtp:                   { exibir: 'main.configuracao.senhasmtp' },
    servidorsmtp:                { exibir: 'main.configuracao.servidorsmtp' },
    portasmtp:                   { exibir: 'main.configuracao.portasmtp', tipo: 'numeric', keyfilter: 'num' },
    confirmacaocadastro:         { exibir: 'main.configuracao.confirmacaocadastro', tipo: 'enum', entidade: 'configuracao.confirmacaocadastro' },
    mensagempin:                 { exibir: 'main.configuracao.mensagempin' },
    requercpf:                   { exibir: 'main.configuracao.requercpf', tipo: 'enum', entidade: 'configuracao.requercpf' },
    requercidade:                { exibir: 'main.configuracao.requercidade', tipo: 'enum', entidade: 'configuracao.requercidade' },
    requerdatanascimento:        { exibir: 'main.configuracao.requerdatanascimento', tipo: 'enum', entidade: 'configuracao.requerdatanascimento' },
    utilizavoucher:              { exibir: 'main.configuracao.utilizavoucher' },
    tempoexibicaopatrocinio:     { exibir: 'main.configuracao.tempoexibicaopatrocinio', tipo: 'numeric', keyfilter: 'num' },
    nomecaptive:                 { exibir: 'main.configuracao.nomecaptive' },
    imagemtelainicial:           { exibir: 'main.configuracao.imagemtelainicial' },
    imagemtelainicialformato:    { exibir: 'main.configuracao.imagemtelainicialformato', tipo: 'enum', entidade: 'configuracao.imagemtelainicialformato' },
    espacamentoextendido:        { exibir: 'main.configuracao.espacamentoextendido', tipo: 'numeric', keyfilter: 'num' },
    temacaptive:                 { exibir: 'main.configuracao.temacaptive', tipo: 'enum', entidade: 'configuracao.temacaptive' },
    tamanhofontecaptive:         { exibir: 'main.configuracao.tamanhofontecaptive', tipo: 'enum', entidade: 'configuracao.tamanhofontecaptive' },
};

// ─── Renderers ────────────────────────────────────────────────────────────────

const renderersAdmin = {
    'ativarcaptive.template': (rowData) => <i className={`pi ${rowData.ativarcaptive ? 'pi-check text-green-500' : 'pi-times text-red-400'}`} />,
    'homologacaointegracao.entidade': HomologacaoIntegracao,
    'homologacaointegracao.template': (rowData) => rowData.homologacaointegracao?.descricao || '',
    'configuracao.confirmacaocadastro':  ConfiguracaoConfirmacaoCadastroEnum,
    'configuracao.requercpf':            ConfiguracaoRequercpfEnum,
    'configuracao.requercidade':         ConfiguracaoRequercidadeEnum,
    'configuracao.requerdatanascimento': ConfiguracaoRequerdatanascimentoEnum,
    'configuracao.tipoenvioemail':       ConfiguracaoTipoEnvioEmailEnum,
    'configuracao.identificacaomercadopago': ConfiguracaoIdentificacaoMercadoPagoEnum,
    'configuracao.tipologin':            TipoLoginEnum,
    'configuracao.imagemtelainicialformato': ConfiguracaoImagemTelaInicialFormatoEnum,
    'configuracao.temacaptive':           ConfiguracaoTemaCaptiveEnum,
    'configuracao.tamanhofontecaptive':   ConfiguracaoTamanhoFonteCaptiveEnum,
};

const renderers = {
    'homologacaointegracao.entidade': HomologacaoIntegracao,
    'configuracao.confirmacaocadastro':  ConfiguracaoConfirmacaoCadastroEnum,
    'configuracao.requercpf':            ConfiguracaoRequercpfEnum,
    'configuracao.requercidade':         ConfiguracaoRequercidadeEnum,
    'configuracao.requerdatanascimento': ConfiguracaoRequerdatanascimentoEnum,
    'configuracao.tipoenvioemail':       ConfiguracaoTipoEnvioEmailEnum,
    'configuracao.identificacaomercadopago': ConfiguracaoIdentificacaoMercadoPagoEnum,
    'configuracao.tipologin':            TipoLoginEnum,
    'configuracao.imagemtelainicialformato': ConfiguracaoImagemTelaInicialFormatoEnum,
    'configuracao.temacaptive':           ConfiguracaoTemaCaptiveEnum,
    'configuracao.tamanhofontecaptive':   ConfiguracaoTamanhoFonteCaptiveEnum,
};

// ─── Formulário padrão do grid (2 abas: Básico / Avançado) ───────────────────

class ConfiguracaoFormularioGrid extends Component {
    render() {
        const { model, contexto } = this.props;
        const estendida = model.imagemtelainicialformato.value?.id === 'main.configuracao.imagemtelainicialformato.estendida';
        const integracao = model.homologacaointegracao.value;
        const desativado = (campo) => !!integracao?.[campo]?.endsWith('.desativado');
        return (
            <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
                <TabPanel header={UtilService.traduzir('main.configuracao.aba.basico')} leftIcon="pi pi-home mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.descricao} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.confirmacaocadastro} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelBoolean model={model.ativarcaptive} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelBoolean model={model.ativarequivalencia} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelBoolean model={model.utilizavoucher} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.requercpf} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.requercidade} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.requerdatanascimento} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.tempoexibicaopatrocinio} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelBoolean model={model.logincommac} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.diasvalidadelogincommac} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-12 mt-3">
                            <ModelTextInput model={model.mensagempin} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>

                <TabPanel header={UtilService.traduzir('main.configuracao.aba.avancado')} leftIcon="pi pi-cog mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelUrl model={model.urlredirect} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelBoolean model={model.exigirtermosdeuso} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelBoolean model={model.ativarsms} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelBoolean model={model.ativaremail} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelSenha model={model.apitokensms} contexto={contexto} mostrarMetricas={false} />
                        </div>

                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.tipoenvioemail} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.origem} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.usuariosmtp} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelSenha model={model.senhasmtp} contexto={contexto} mostrarMetricas={false} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.servidorsmtp} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelInputNumber model={model.portasmtp} contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>

                <TabPanel header={UtilService.traduzir('main.configuracao.aba.integracao')} leftIcon="pi pi-link mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelDropDown model={model.homologacaointegracao} contexto={contexto} />
                        </div>
                        {!desativado('obrigatoriedadeurl') && (
                            <div className="field col-12 md:col-6 mt-3">
                                <ModelUrl model={model.integracaourl} contexto={contexto} />
                            </div>
                        )}
                        {!desativado('obrigatoriedadecredencial') && (
                            <div className="field col-12 md:col-6 mt-3">
                                <ModelSenha model={model.integracaocredencial} contexto={contexto} mostrarMetricas={false} />
                            </div>
                        )}
                        {!desativado('obrigatoriedadesecret') && (
                            <div className="field col-12 md:col-6 mt-3">
                                <ModelSenha model={model.integracaosecret} contexto={contexto} mostrarMetricas={false} />
                            </div>
                        )}
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelSenha model={model.mercadopagoaccesstoken} contexto={contexto} mostrarMetricas={false} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelTextInput model={model.mercadopagopublickey} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelSenha model={model.mercadopagowebhooksecret} contexto={contexto} mostrarMetricas={false} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelDropDown model={model.identificacaomercadopago} contexto={contexto} />
                        </div>
                        <div className="field col-12">
                            <MercadoPagoWebhookAjuda />
                        </div>
                    </div>
                </TabPanel>

                <TabPanel header={UtilService.traduzir('main.configuracao.aba.aparencia')} leftIcon="pi pi-palette mr-2">
                    <div className="grid">
                        <div className="field col-12 md:col-8 mt-3">
                            <ModelMultiSelect model={model.tipologin} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelDropDown model={model.tipologinpadrao} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelTextInput model={model.nomecaptive} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-4 mt-3">
                            <ModelFile model={model.imagemtelainicial} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelDropDown model={model.imagemtelainicialformato} contexto={contexto} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelSlider model={{ ...model.espacamentoextendido, disabled: !estendida }} contexto={contexto} min={0} max={300} />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelDropDown
                                model={model.temacaptive}
                                contexto={contexto}
                                itemTemplateCustom={(opt) => <TemaCaptiveOptionLabel chave={opt.id} />}
                                valueTemplateCustom={(val) => <TemaCaptiveOptionLabel chave={val?.id} />}
                            />
                        </div>
                        <div className="field col-12 md:col-6 mt-3">
                            <ModelDropDown
                                model={model.tamanhofontecaptive}
                                contexto={contexto}
                                itemTemplateCustom={(opt) => <TamanhoFonteCaptiveOptionLabel chave={opt.id} />}
                                valueTemplateCustom={(val) => <TamanhoFonteCaptiveOptionLabel chave={val?.id} />}
                            />
                        </div>
                        <div className="field col-12 mt-3">
                            <TesteAparenciaCaptiveButton contexto={contexto} />
                        </div>
                    </div>
                </TabPanel>
            </TabViewComErro>
        );
    }
}

// ─── Formulário com seções (templateSimples e modo tenant) ────────────────────

class ConfiguracaoFormulario extends Component {
    render() {
        const { model, contexto } = this.props;
        const estendida = model.imagemtelainicialformato.value?.id === 'main.configuracao.imagemtelainicialformato.estendida';
        const integracao = model.homologacaointegracao.value;
        const desativado = (campo) => !!integracao?.[campo]?.endsWith('.desativado');
        return (
            <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
                <TabPanel header={UtilService.traduzir('main.configuracao.aba.basico')} leftIcon="pi pi-home mr-2">
                    <div className="grid">
                        <div className="col-12 md:col-6">
                            <Fieldset legend={UtilService.traduzir('main.configuracao.secao.geral')} className="mb-3">
                                <div className="grid">
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelTextInput model={model.descricao} contexto={contexto} />
                                    </div>
                                    <div className="field col-6 md:col-3 mt-3">
                                        <ModelBoolean model={model.ativarcaptive} contexto={contexto} />
                                    </div>
                                    <div className="field col-6 md:col-3 mt-3">
                                        <ModelBoolean model={model.ativarequivalencia} contexto={contexto} />
                                    </div>
                                </div>
                            </Fieldset>

                            <Fieldset legend={UtilService.traduzir('main.configuracao.secao.cadastro')} className="mb-3">
                                <div className="grid">
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelDropDown model={model.confirmacaocadastro} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelDropDown model={model.requercpf} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelDropDown model={model.requercidade} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelDropDown model={model.requerdatanascimento} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 mt-3">
                                        <ModelTextInput model={model.mensagempin} contexto={contexto} />
                                    </div>
                                </div>
                            </Fieldset>

                            <Fieldset legend={UtilService.traduzir('main.configuracao.secao.voucher')} className="mb-3">
                                <div className="grid">
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelBoolean model={model.utilizavoucher} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelTextInput model={model.tempoexibicaopatrocinio} contexto={contexto} />
                                    </div>
                                </div>
                            </Fieldset>

                            <Fieldset legend={UtilService.traduzir('main.configuracao.secao.aparencia')} className="mb-3">
                                <div className="grid">
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelTextInput model={model.nomecaptive} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelFile model={model.imagemtelainicial} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelDropDown model={model.imagemtelainicialformato} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelSlider model={{ ...model.espacamentoextendido, disabled: !estendida }} contexto={contexto} min={0} max={300} />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelDropDown
                                            model={model.temacaptive}
                                            contexto={contexto}
                                            itemTemplateCustom={(opt) => <TemaCaptiveOptionLabel chave={opt.id} />}
                                            valueTemplateCustom={(val) => <TemaCaptiveOptionLabel chave={val?.id} />}
                                        />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelDropDown
                                            model={model.tamanhofontecaptive}
                                            contexto={contexto}
                                            itemTemplateCustom={(opt) => <TamanhoFonteCaptiveOptionLabel chave={opt.id} />}
                                            valueTemplateCustom={(val) => <TamanhoFonteCaptiveOptionLabel chave={val?.id} />}
                                        />
                                    </div>
                                    <div className="field col-12 mt-3">
                                        <TesteAparenciaCaptiveButton contexto={contexto} />
                                    </div>
                                </div>
                            </Fieldset>
                        </div>

                        <div className="col-12 md:col-6">
                            <Fieldset legend={UtilService.traduzir('main.configuracao.secao.hotspot')} className="mb-3">
                                <div className="grid">
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelUrl model={model.urlredirect} contexto={contexto} />
                                    </div>
                                    <div className="field col-6 md:col-3 mt-3">
                                        <ModelBoolean model={model.logincommac} contexto={contexto} />
                                    </div>
                                    <div className="field col-6 md:col-3 mt-3">
                                        <ModelTextInput model={model.diasvalidadelogincommac} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelMultiSelect model={model.tipologin} contexto={contexto} />
                                    </div>
                                    <div className="field col-6 md:col-3 mt-3">
                                        <ModelDropDown model={model.tipologinpadrao} contexto={contexto} />
                                    </div>
                                    <div className="field col-6 md:col-3 mt-3">
                                        <ModelBoolean model={model.exigirtermosdeuso} contexto={contexto} />
                                    </div>
                                    <div className="field col-6 md:col-3 mt-3">
                                        <ModelBoolean model={model.ativarsms} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelSenha model={model.apitokensms} contexto={contexto} mostrarMetricas={false} />
                                    </div>
                                    <div className="field col-6 md:col-3 mt-3">
                                        <ModelBoolean model={model.ativaremail} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-4 mt-3">
                                        <ModelDropDown model={model.tipoenvioemail} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-4 mt-3">
                                        <ModelTextInput model={model.origem} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-4 mt-3">
                                        <ModelTextInput model={model.usuariosmtp} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-4 mt-3">
                                        <ModelSenha model={model.senhasmtp} contexto={contexto} mostrarMetricas={false} />
                                    </div>
                                    <div className="field col-12 md:col-4 mt-3">
                                        <ModelTextInput model={model.servidorsmtp} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-4 mt-3">
                                        <ModelInputNumber model={model.portasmtp} contexto={contexto} />
                                    </div>
                                </div>
                            </Fieldset>

                            <Fieldset legend={UtilService.traduzir('main.configuracao.aba.integracao')} className="mb-3">
                                <div className="grid">
                                    <div className="field col-12 mt-3">
                                        <ModelDropDown model={model.homologacaointegracao} contexto={contexto} />
                                    </div>
                                    {!desativado('obrigatoriedadeurl') && (
                                        <div className="field col-12 md:col-6 mt-3">
                                            <ModelUrl model={model.integracaourl} contexto={contexto} />
                                        </div>
                                    )}
                                    {!desativado('obrigatoriedadecredencial') && (
                                        <div className="field col-12 md:col-6 mt-3">
                                            <ModelSenha model={model.integracaocredencial} contexto={contexto} mostrarMetricas={false} />
                                        </div>
                                    )}
                                    {!desativado('obrigatoriedadesecret') && (
                                        <div className="field col-12 md:col-6 mt-3">
                                            <ModelSenha model={model.integracaosecret} contexto={contexto} mostrarMetricas={false} />
                                        </div>
                                    )}
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelSenha model={model.mercadopagoaccesstoken} contexto={contexto} mostrarMetricas={false} />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelTextInput model={model.mercadopagopublickey} contexto={contexto} />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelSenha model={model.mercadopagowebhooksecret} contexto={contexto} mostrarMetricas={false} />
                                    </div>
                                    <div className="field col-12 md:col-6 mt-3">
                                        <ModelDropDown model={model.identificacaomercadopago} contexto={contexto} />
                                    </div>
                                    <div className="field col-12">
                                        <MercadoPagoWebhookAjuda />
                                    </div>
                                </div>
                            </Fieldset>
                        </div>
                    </div>
                </TabPanel>

                {/* Aba desabilitada por hora - infraestrutura de tabs mantida pra uso futuro,
                    o conteudo que antes vivia aqui (Integracao/Aparencia) foi consolidado na
                    aba Basico a pedido do usuario. */}
                <TabPanel header={UtilService.traduzir('main.configuracao.aba.avancado')} leftIcon="pi pi-cog mr-2" disabled />
            </TabViewComErro>
        );
    }
}

// ─── Página principal ─────────────────────────────────────────────────────────

class ConfiguracaoPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            model:           this.modelInicial(),
            carregando:      true,
            salvando:        false,
            tentativaSalvar: 0,
            modelSimples:    this.modelInicial(),
            salvandoSimples: false,
            tentativaSalvarSimples: 0,
            emModoSimples:   false,
            nomeSimples:     '',
        };
    }

    isAdmin() {
        return !!this.props.permissoes?.permiteacessogeral;
    }

    modelInicial() {
        return {
            id:                      { value: null },
            descricao:               { exibir: 'main.configuracao.descricao', value: '' },
            ativarcaptive:           { exibir: 'main.configuracao.ativarcaptive', value: false },
            ativarequivalencia:      { exibir: 'main.configuracao.ativarequivalencia', value: true },
            homologacaointegracao:   { exibir: 'main.configuracao.homologacaointegracao', tipo: 'relacao', camporelacao: 'descricao', entidade: 'homologacaointegracao.entidade', value: null },
            integracaourl:           { exibir: 'main.configuracao.integracaourl', tipo: 'url', validacao: { url: true, customizada: (def, model) => validarObrigatoriedadeIntegracao(def, model, 'obrigatoriedadeurl') }, value: '' },
            integracaocredencial:    { exibir: 'main.configuracao.integracaocredencial', validacao: { customizada: (def, model) => validarObrigatoriedadeIntegracao(def, model, 'obrigatoriedadecredencial') }, value: '' },
            integracaosecret:        { exibir: 'main.configuracao.integracaosecret', validacao: { customizada: (def, model) => validarObrigatoriedadeIntegracao(def, model, 'obrigatoriedadesecret') }, value: '' },
            mercadopagoaccesstoken:  { exibir: 'main.configuracao.mercadopagoaccesstoken', value: '' },
            mercadopagopublickey:    { exibir: 'main.configuracao.mercadopagopublickey', value: '' },
            mercadopagowebhooksecret: { exibir: 'main.configuracao.mercadopagowebhooksecret', value: '' },
            identificacaomercadopago: { exibir: 'main.configuracao.identificacaomercadopago', tipo: 'enum', entidade: 'configuracao.identificacaomercadopago', value: ConfiguracaoIdentificacaoMercadoPagoEnum.getDefault() },
            urlredirect:             { exibir: 'main.configuracao.urlredirect', tipo: 'url', validacao: { url: true }, value: '' },
            logincommac:             { exibir: 'main.configuracao.logincommac', value: false },
            diasvalidadelogincommac: { exibir: 'main.configuracao.diasvalidadelogincommac', tipo: 'numeric', keyfilter: 'num', value: null },
            tipologin:               { exibir: 'main.configuracao.tipologin', tipo: 'multiselect', entidade: 'configuracao.tipologin', validacao: { obrigatorio: true }, value: [] },
            tipologinpadrao:         { exibir: 'main.configuracao.tipologinpadrao', tipo: 'enum', entidade: 'configuracao.tipologin', value: null },
            exigirtermosdeuso:       { exibir: 'main.configuracao.exigirtermosdeuso', value: false },
            apitokensms:             { exibir: 'main.configuracao.apitokensms', value: '' },
            ativarsms:               { exibir: 'main.configuracao.ativarsms', value: false },
            ativaremail:             { exibir: 'main.configuracao.ativaremail', value: false },
            tipoenvioemail:          { exibir: 'main.configuracao.tipoenvioemail', tipo: 'enum', entidade: 'configuracao.tipoenvioemail', value: null },
            origem:                  { exibir: 'main.configuracao.origem', value: '' },
            usuariosmtp:             { exibir: 'main.configuracao.usuariosmtp', value: '' },
            senhasmtp:               { exibir: 'main.configuracao.senhasmtp', value: '' },
            servidorsmtp:            { exibir: 'main.configuracao.servidorsmtp', value: '' },
            portasmtp:               { exibir: 'main.configuracao.portasmtp', tipo: 'numeric', keyfilter: 'num', value: null },
            confirmacaocadastro:     { exibir: 'main.configuracao.confirmacaocadastro', tipo: 'enum', entidade: 'configuracao.confirmacaocadastro', value: null },
            mensagempin:             { exibir: 'main.configuracao.mensagempin', value: '' },
            requercpf:               { exibir: 'main.configuracao.requercpf', tipo: 'enum', entidade: 'configuracao.requercpf', value: null },
            requercidade:            { exibir: 'main.configuracao.requercidade', tipo: 'enum', entidade: 'configuracao.requercidade', value: null },
            requerdatanascimento:    { exibir: 'main.configuracao.requerdatanascimento', tipo: 'enum', entidade: 'configuracao.requerdatanascimento', value: null },
            utilizavoucher:          { exibir: 'main.configuracao.utilizavoucher', value: false },
            tempoexibicaopatrocinio: { exibir: 'main.configuracao.tempoexibicaopatrocinio', tipo: 'numeric', keyfilter: 'num', value: null },
            nomecaptive:             { exibir: 'main.configuracao.nomecaptive', value: '' },
            imagemtelainicial:       { exibir: 'main.configuracao.imagemtelainicial', value: '' },
            imagemtelainicialformato: { exibir: 'main.configuracao.imagemtelainicialformato', tipo: 'enum', entidade: 'configuracao.imagemtelainicialformato', value: null },
            espacamentoextendido:    { exibir: 'main.configuracao.espacamentoextendido', value: 300 },
            temacaptive:             { exibir: 'main.configuracao.temacaptive', tipo: 'enum', entidade: 'configuracao.temacaptive', value: null },
            tamanhofontecaptive:     { exibir: 'main.configuracao.tamanhofontecaptive', tipo: 'enum', entidade: 'configuracao.tamanhofontecaptive', value: null },
        };
    }

    popularModel(conf) {
        const model = this.modelInicial();
        Object.keys(model).forEach(key => {
            if (conf[key] === undefined || conf[key] === null) return;
            if (model[key].tipo === 'enum') {
                model[key].value = { id: conf[key], descricao: conf[key] };
            } else if (model[key].tipo === 'relacao') {
                // Blueprint find do Sails já popula associações singulares por padrão — conf[key]
                // normalmente já chega como objeto ({id, descricao, ...}). O fallback (bare id vira
                // {id, descricao: id}) só cobre o caso de vir despopulado, mesmo padrão de
                // UtilService.prepararModel.
                model[key].value = typeof conf[key] === 'object' ? conf[key] : { id: conf[key], descricao: conf[key] };
            } else {
                model[key].value = conf[key];
            }
        });
        return model;
    }

    async componentDidMount() {
        if (this.isAdmin()) {
            this.setState({ carregando: false });
            return;
        }
        try {
            // EntidadeBase.list()/ApiService.get() sempre embrulham a resposta como
            // { data: { count, registros }, status } - nunca { registros, count } direto na raiz
            // (mesmo formato que EntityGrid.atualizar() consome pra grade padrão).
            const result = await Configuracao.list();
            if (result?.data?.registros?.length) {
                const conf = result.data.registros[0];
                this.setState({ model: this.popularModel(conf) });
            }
        } finally {
            this.setState({ carregando: false });
        }
    }

    buildContexto() {
        return {
            traduzir:        (key) => UtilService.traduzir(key),
            traduzirModel:   (m) => UtilService.traduzir(m.exibir),
            traduzirHelp:    (fieldName) => {
                const key = `main.configuracao.${fieldName}.help`;
                const result = UtilService.traduzir(key);
                return result === key ? '' : result;
            },
            getRenderer:     (path) => renderers[path],
            updateModelPath: (path, valor) => {
                this.setState(prev => {
                    const model = lodash.cloneDeep(prev.model);
                    lodash.set(model, path, valor);
                    return { model };
                });
            },
            salvar:          () => this.salvar(),
            // TabViewComErro le contexto.state.tentativaSalvar pra saber quando pular pra aba
            // com o primeiro erro - mesmo padrao de EntityGrid, so que aqui o contexto e um
            // objeto proprio (nao a instancia do EntityGrid), entao precisa ser repassado a mao.
            state:           { tentativaSalvar: this.state.tentativaSalvar },
            // Formulario simplificado usa colunas estreitas (md:col-4/col-6) perto da borda
            // direita da tela - tooltip com a posicao padrao (direita) nao tem espaco pra
            // aparecer. Os componentes Model* leem isso opcionalmente (contexto.tooltipPosition),
            // sem afetar nenhuma outra tela que nao define essa chave no proprio contexto.
            tooltipPosition: 'bottom',
        };
    }

    buildContextoSimples() {
        return {
            traduzir:        (key) => UtilService.traduzir(key),
            traduzirModel:   (m) => UtilService.traduzir(m.exibir),
            traduzirHelp:    (fieldName) => {
                const key = `main.configuracao.${fieldName}.help`;
                const result = UtilService.traduzir(key);
                return result === key ? '' : result;
            },
            getRenderer:     (path) => renderers[path],
            updateModelPath: (path, valor) => {
                this.setState(prev => {
                    const modelSimples = lodash.cloneDeep(prev.modelSimples);
                    lodash.set(modelSimples, path, valor);
                    return { modelSimples };
                });
            },
            salvar:          () => this.salvarSimples(),
            state:           { tentativaSalvar: this.state.tentativaSalvarSimples },
            tooltipPosition: 'bottom',
        };
    }

    async salvar() {
        const model = UtilService.validarEsquema(this.state.model);
        this.setState({ model, tentativaSalvar: this.state.tentativaSalvar + 1 });
        if (!model.valido) return;

        this.setState({ salvando: true });
        try {
            const procedimento = await Configuracao.update(this.state.model);
            if (procedimento.status) {
                UtilService.showToast({ severity: 'success', summary: UtilService.traduzir('main.registroAtualizado'), detail: UtilService.traduzir('main.registroAtualizado.sucesso') });
            } else {
                UtilService.showToast({ sticky: true, severity: 'error', summary: UtilService.traduzir('main.erroSalvar.plural'), detail: UtilService.traduzir('main.erroSalvar.detalhe') });
            }
        } finally {
            this.setState({ salvando: false });
        }
    }

    async salvarSimples() {
        const modelSimples = UtilService.validarEsquema(this.state.modelSimples);
        this.setState({ modelSimples, tentativaSalvarSimples: this.state.tentativaSalvarSimples + 1 });
        if (!modelSimples.valido) return;

        this.setState({ salvandoSimples: true });
        try {
            const procedimento = await Configuracao.update(this.state.modelSimples);
            if (procedimento.status) {
                UtilService.showToast({ severity: 'success', summary: UtilService.traduzir('main.registroAtualizado'), detail: UtilService.traduzir('main.registroAtualizado.sucesso') });
            } else {
                UtilService.showToast({ sticky: true, severity: 'error', summary: UtilService.traduzir('main.erroSalvar.plural'), detail: UtilService.traduzir('main.erroSalvar.detalhe') });
            }
        } finally {
            this.setState({ salvandoSimples: false });
        }
    }

    processos() {
        return [{
            label:    'main.configuracao.verformulario',
            icon:     'pi pi-cog',
            disabled: true,
            ativo: (processo, selected) => {
                processo.disabled = selected.length !== 1;
                return processo;
            },
            command: () => {
                const row = this.gridRef?.getSelected()?.[0];
                if (!row) return;
                this.setState({
                    emModoSimples: true,
                    nomeSimples:   row.descricao || '',
                    modelSimples:  this.popularModel(row),
                }, () => {
                    this.gridRef?.setModoVisualizacao('simples');
                });
            },
        }];
    }

    renderTemplateSimples(header) {
        const ctx = this.buildContextoSimples();
        return (
            <div className="surface-card border-round shadow-2">
                {header}
                <div className="p-3">
                    <ConfiguracaoFormulario model={this.state.modelSimples} contexto={ctx} />
                </div>
            </div>
        );
    }

    renderAdmin() {
        const { emModoSimples, nomeSimples, salvandoSimples } = this.state;
        const breadcrumbPai = emModoSimples
            ? [{ label: UtilService.traduzir('main.configuracao.plural') }]
            : undefined;
        const breadcrumbAtual = emModoSimples ? nomeSimples : undefined;

        return (
            <EntityGrid
                ref={(ref) => { this.gridRef = ref; }}
                entidade={Configuracao}
                model={modelAdmin}
                identidade="main.configuracao"
                permissoes={this.props.permissoes}
                icone="pi-cog"
                storageKey="dt-configuracoes"
                processos={this.processos()}
                renderers={renderersAdmin}
                configuracao={this.props.configuracao}
                navigate={this.props.navigate}
                location={this.props.location}
                searchparams={this.props.searchparams}
                breadcrumbPai={breadcrumbPai}
                breadcrumbAtual={breadcrumbAtual}
                formulario={(m, ctx) => <ConfiguracaoFormularioGrid model={m} contexto={ctx} />}
                ocultarToggleSimples
                ocultarAtualizarSimples
                templateSimples={(header) => this.renderTemplateSimples(header)}
                onAtualizarSimples={() => {}}
                toolbarFimSimples={
                    <Button
                        label={UtilService.traduzir('main.salvar')}
                        icon="pi pi-save"
                        loading={salvandoSimples}
                        onClick={() => this.salvarSimples()}
                        className="mr-2"
                    />
                }
            />
        );
    }

    renderFormulario() {
        const { model, carregando, salvando } = this.state;
        const ctx = this.buildContexto();
        const { navigate } = this.props;

        const breadcrumbHome = navigate
            ? { icon: 'pi pi-home', command: () => navigate({ pathname: '/dashboard' }) }
            : { icon: 'pi pi-home' };

        return (
            <div className="surface-card border-round shadow-2">
                {navigate && (
                    <BreadCrumb
                        model={[{ label: UtilService.traduzir('main.configuracao.plural') }]}
                        home={breadcrumbHome}
                        className="border-none surface-section p-4 mb-1"
                    />
                )}
                <div className="p-3">
                    <div className="flex justify-content-between align-items-center mb-3">
                        <div className="flex flex-row align-items-center">
                            <Avatar icon="pi pi-cog" size="large" />
                            <p className="m-0 p-2 text-2xl font-bold text-900">{UtilService.traduzir('main.configuracao.plural')}</p>
                        </div>
                        <Button
                            label={UtilService.traduzir('main.salvar')}
                            icon="pi pi-save"
                            loading={salvando}
                            onClick={() => this.salvar()}
                        />
                    </div>
                    {carregando ? (
                        <div className="flex justify-content-center p-5">
                            <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }} />
                        </div>
                    ) : (
                        <ConfiguracaoFormulario model={model} contexto={ctx} />
                    )}
                </div>
            </div>
        );
    }

    render() {
        return this.isAdmin() ? this.renderAdmin() : this.renderFormulario();
    }
}

export default ConfiguracaoPage;
